import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

const PageTracker = () => {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Track page view when location changes
    const pageName = getPageName(location.pathname);
    
    trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      hash: location.hash,
    });
  }, [location, trackPageView]);

  return null; // This component doesn't render anything
};

// Helper function to convert path to readable page name
const getPageName = (pathname) => {
  // Remove leading slash and convert to title case
  const path = pathname.replace(/^\//, '');
  
  // Handle special cases
  const pageMap = {
    '': 'Home',
    'auth': 'Authentication',
    'dashboard': 'Dashboard',
    'member-home': 'Member Home',
    'create-group': 'Create Group',
    'group-creation-success': 'Group Creation Success',
    'saved': 'Saved Items',
    'reset-password-request': 'Reset Password Request',
    'reset-password-confirm': 'Reset Password Confirm',
    'admin-profile': 'Admin Profile',
    'member-profile': 'Member Profile',
    'privacy-policy': 'Privacy Policy',
    'terms-of-service': 'Terms of Service',
    'app-download': 'App Download',
    'fast-times': 'Fast Times',
    'group-claim': 'Group Claim',
    'community-onboarding': 'Community Onboarding',
    'signup': 'Sign Up',
    'stripe-connect-settings': 'Stripe Connect Settings',
    'group-invite': 'Group Invite',
  };

  // Check for direct matches
  if (pageMap[path]) {
    return pageMap[path];
  }

  // Handle dynamic routes
  if (path.startsWith('names/')) {
    return 'Name Claim Request';
  }
  if (path.startsWith('group/')) {
    if (path.includes('/event/')) {
      return 'Event Details';
    } else if (path.includes('/class/')) {
      return 'Class Details';
    } else if (path.includes('/membership/')) {
      return 'Membership Details';
    } else if (path.includes('/members')) {
      return 'Members Admin';
    } else {
      return 'Group Page';
    }
  }

  if (path.startsWith('onboarding/')) {
    const step = path.split('/')[1];
    switch (step) {
      case 'intro': return 'Onboarding Intro';
      case 'identity-verification': return 'Identity Verification';
      case 'profile-creation': return 'Profile Creation';
      case 'anniversary-date': return 'Anniversary Date';
      case 'kids-birthday': return 'Kids Birthday';
      case 'yartzheits': return 'Yartzheits';
      default: return 'Onboarding';
    }
  }

  // Fallback: convert path to title case
  return path
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ') || 'Unknown Page';
};

export default PageTracker;
